import vDrag from "./vDrag.js";

function install(Vue) {
  Vue.use(vDrag);
}

export default install;